import type { FC, ReactNode } from 'react'
import type { CloudShape } from '@/constants/sprites'

import { PixelSprite } from '@/components/pixel/pixel-sprite'

import { CLOUD_PALETTE, CLOUDS } from '@/constants/sprites'

interface PixelCloudProps {
    shape?: CloudShape
    className?: string
}

const PixelCloud: FC<PixelCloudProps> = ({ shape = 'big', className }): ReactNode => {
    return <PixelSprite rows={CLOUDS[shape]} palette={CLOUD_PALETTE} className={className} />
}

export default PixelCloud
